<template>
  <a-modal
    title="新增服务节点"
    v-model="isShow"
    centered
    :mask-closable="false"
    @ok="handleSubmit"
  >
    <search @submit="submitSearch" />
    <a-table
      :scroll="{ y: 350 }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    />
  </a-modal>
</template>

<script>
import { findOrderServiceNodeOptions } from '@/api/order_service_node'
import Search from '@/views/orders/tenant/operation_modal/NewOrderServiceNodeSearch'

export default {
  name: 'NewOrderServiceNode',
  components: {
    Search
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      query: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    columns() {
      return [
        {
          title: '服务节点',
          dataIndex: 'name'
        },
        {
          title: '说明',
          dataIndex: 'description'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    fetchData() {
      this.selectedRowKeys = []
      this.selectedRows = []
      findOrderServiceNodeOptions(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      this.fetchData()
    },

    handleSubmit(e) {
      e.preventDefault()
      this.isShow = false
      this.$emit('submit', this.selectedRows)
    }
  }
}
</script>

